import DatabaseSqlite, {Statement} from "better-sqlite3";
import Database from "./Database";
import Document from "../Entity/Document";

export default class DocumentRepository {
    private database: DatabaseSqlite.Database;

    public constructor(
        database: Database
    ) {
        this.database = database.getDatabase();
    }

    public getCount(): number {
        try {
            const select: Statement<string[], { count_docs: number }> = this.database.prepare("SELECT COUNT(*) as count_docs FROM docs WHERE status = 'Pending' OR status = 'Downloading' OR status = 'Paused';");
            const row = select.get();
            return row?.count_docs || 0;
        } catch (error) {
            console.error("Error when attempting to count the documents pending to download:", error);
        }

        return 0;
    }

    public getPendingDownload(): Document[] {
        try {
            const select = this.database.prepare("SELECT * FROM docs WHERE status = 'Pending' OR status = 'Downloading' OR status = 'Paused' ORDER BY position ASC;");
            const rows: any[] = select.all();
            return rows.map(row => this.createDocumentFromRow(row));
        } catch (error) {
            console.error("Error when attempting to retrieve documents pending to download:", error);
            return [];
        }
    }

    public getById(id: string): Document | null {
        try {
            const select = this.database.prepare("SELECT * FROM docs WHERE ref = ?;");
            const row: any = select.get(id);
            if (row) {
                return this.createDocumentFromRow(row);
            }
        } catch (error) {
            console.error("Error when attempting to retrieve document by ID:", error);
        }

        return null;
    }

    private createDocumentFromRow(row: any): Document {
        return new Document(row.ref, row.name, row.filesize, row.text, row.entity_changed, row.date_downloaded, row.time_lapse, row.last_verified, row.format, row.description, row.mimetype, row.uuid, row.entity_bundle, row.status, row.position);
    }

    public save(document: Document): void {
        this.getById(document.getId()) ? this.update(document) : this.insert(document);
    }

    private insert(document: Document): void {
        try {
            const insert = this.database.prepare("INSERT OR IGNORE INTO docs VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)");
            insert.run(document.getId(), document.getName(), document.getFilesize(), document.getText(), document.getEntityChanged(), document.getDateDownloaded(), document.getTimeLapse(), document.getLastVerified(), document.getFormat(), document.getDescription(), document.getMimetype(), document.getUuid(), document.getEntityBundle(), document.getStatus(), document.getPosition());
        } catch (error) {
            console.error("Error when attempting to insert the document:", error);
        }
    }

    private update(document: Document): void {
        try {
            const update = this.database.prepare("UPDATE docs SET name = ?, filesize = ?, text = ?, entity_changed = ?, date_downloaded = ?, time_lapse = ?, last_verified = ?, format = ?, description = ?, mimetype = ?, uuid = ?, entity_bundle = ?, status = ?, position = ? WHERE ref = ?");
            update.run(document.getName(), document.getFilesize(), document.getText(), document.getEntityChanged(), document.getDateDownloaded(), document.getTimeLapse(), document.getLastVerified(), document.getFormat(), document.getDescription(), document.getMimetype(), document.getUuid(), document.getEntityBundle(), document.getStatus(), document.getPosition(), document.getId());
        } catch (error) {
            console.error("Error when attempting to update the document:", error);
        }
    }

    public remove(id: string): void {
        try {
            const remove = this.database.prepare("DELETE FROM docs WHERE ref = ?;");
            remove.run(id);
        } catch (error) {
            console.error("Error when attempting to remove the document:", error);
        }
    }
}